export const onSetAssets = (assets) => ({
  type: 'SET_ASSETS',
  assets
})

export const onRemoveAsset = (index) => ({
  type: 'REMOVE_ASSET',
  index
})
